import React from "react";
import { useParams } from "react-router-dom";
import formatUrl from "utils/formatUrl";

import HasValidInvite from "components/HasValidInvite";
import Login from "pages/Login";

export const InviteLogin: React.FC = () => {
  const { inviteId } = useParams<{ inviteId: string }>();
  const redirectUrl = formatUrl("/invite/:inviteId/accept", { inviteId });

  return (
    <HasValidInvite inviteId={inviteId} validateUser={false}>
      <Login inviteId={inviteId} redirectUrl={redirectUrl} />
    </HasValidInvite>
  );
};
